import { type FunctionComponent } from "react";

import {
  BodyContainer,
  BodyPlaceholder,
  Container,
  HeaderContainer,
  OuterContainer,
  StyledHeaderIcon,
  TitlePlaceholder,
} from "./styles";

type Props = {
  className?: string;
};

export const SearchAIWidgetPlaceholder: FunctionComponent<Props> = ({ className }) => (
  <OuterContainer className={className}>
    <Container>
      <HeaderContainer>
        <StyledHeaderIcon />
        <TitlePlaceholder />
      </HeaderContainer>
      <BodyContainer>
        <BodyPlaceholder $size={16} />
        <BodyPlaceholder $size={106} />
        <BodyPlaceholder $size={35} />
        <BodyPlaceholder $size={80} />
      </BodyContainer>
    </Container>
  </OuterContainer>
);

SearchAIWidgetPlaceholder.displayName = "SearchAIWidgetPlaceholder";
